import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Event,
  EventDate,
  Membership,
  OneDayItem,
  OneDayMembership,
  ProductVariant,
  Profile,
  ProfilePublic,
  SkillSummary,
  Toast,
} from 'src/app/core/models';
import {
  AuthService,
  EventService,
  OneDayService,
  ProfileService,
  ShopifyService,
} from 'src/app/core/services';

@Component({
  selector: 'app-one-day-license-menu',
  templateUrl: './one-day-license-menu.component.html',
  styleUrls: ['./one-day-license-menu.component.scss'],
})
export class OneDayLicenseMenuComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private eventService: EventService,
    private oneDayService: OneDayService,
    private profileService: ProfileService,
    private router: Router,
    private shopifyService: ShopifyService
  ) {}
  @Input() event: Event;
  @Input() user: Profile;
  @Input() skillSummary: SkillSummary;

  loading = true;
  membershipsLoading = true;

  eventOrganizer: Profile | ProfilePublic;
  eventDates: EventDate[];
  licenseVariants: ProductVariant[] = [];
  allMemberships: Membership[];

  selectedOneDays: OneDayItem[] = [];
  purchasedOneDays: OneDayMembership[] = [];

  toasts: Toast[] = [];
  toastQueue: any = {};

  ngOnInit(): void {
    this.loadMembershipsAndSkills();
  }

  private loadMembershipsAndSkills(): void {
    this.authService.currentUser$.subscribe((user: Profile) => {
      this.user = user;
      if (user.profile_id) {
        // Check user's paid one-day memberships to avoid re-purchasing
        this.oneDayService
          .getOneDayMemberships(this.event.event_id, this.user.profile_id)
          .subscribe((oneDays) => {
            oneDays.forEach((oneDay) => {
              if (oneDay.purchase_complete) {
                this.purchasedOneDays.push(oneDay);
              }
            });
            // Check user's discipline skill level for this event
            this.oneDayService
              .checkSkillLevelByEvent(this.event.event_id)
              .subscribe((skillSummary) => {
                this.skillSummary = skillSummary;
                this.loadProductVariants();
              });
          });
        this.profileService
          .getMemberships(this.user.profile_id)
          .subscribe((memberships: Membership[]) => {
            if (memberships) {
              this.allMemberships = memberships;
            }
            this.membershipsLoading = false;
          });
      }
    });
  }

  private loadProductVariants(): void {
    this.shopifyService.getProducts().then((products) => {
      const oneDayProduct = products.find((prod) => prod.title === 'One Day Membership');
      if (oneDayProduct) {
        this.eventService.oneDaySkus[this.event.event_discipline].forEach((sku: string) => {
          this.licenseVariants.push(oneDayProduct.variants.find((variant) => variant.sku === sku));
        });
        this.loadEventOrganizerAndDates();
      } else {
        // TODO: Handle missing products ?
      }
    });
  }

  private loadEventOrganizerAndDates(): void {
    this.profileService.getProfileById(this.event.event_organizer).subscribe((organizer) => {
      this.eventOrganizer = organizer;
      this.eventService.getEventDates(this.event.event_id).subscribe((eventDates) => {
        this.eventDates = this.eventService.sortEventDates(eventDates);
        this.loading = false;
      });
    });
  }

  updateSelectedOneDays(controlValue: any): void {
    Object.entries(controlValue).forEach(([key, val]) => {
      const splitKey = key.split('_');
      const event_date_id = parseInt(splitKey[0], 10);
      const eventDate = this.eventDates.find((ed) => ed.event_date_id === event_date_id);
      const variant = this.licenseVariants.find((lv) => lv.sku === splitKey[1]);
      if (val) {
        this.selectedOneDays.push({ eventDate, variant, quantity: 1 });
      } else {
        this.selectedOneDays.splice(
          this.selectedOneDays.findIndex(
            (oneDay) => oneDay.eventDate.event_date_id === event_date_id
          ),
          1
        );
      }
    });
  }

  toAnnualMembership(): void {
    this.router.navigate(['/']);
  }

  get oneDaysSelected(): boolean {
    return !!this.selectedOneDays.length;
  }

  get experienceRequired(): boolean {
    return this.skillSummary && this.skillSummary.is_experienced;
  }
}
